import React, { useMemo } from "react";

import { ApolloProvider } from "@apollo/client/react/context";

import { createApolloClient } from "./config/apollo";
import { useHandleErrorContext } from "./context/error";

interface ApolloProviderWithErrorHandlingProps {
  children: React.ReactNode;
}

export const ApolloProviderWithErrorHandling = ({ children }: ApolloProviderWithErrorHandlingProps) => {
  const handleErrorContext = useHandleErrorContext();
  const apolloClient = useMemo(() => {
    return createApolloClient(handleErrorContext);
  }, [handleErrorContext]);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
